<app-tab-spinner *ngIf="isLoading"></app-tab-spinner>
<div class="form-details-container">
  <p-toast></p-toast>
  <div class="form-details-title">
    <div class="form-thumnail" [inlineSVG]="'assets/icon-tech-list.svg'"></div>
    <div class="form-name"><input disabled="disabled" value="Servicer Profile" /></div>
    <div class="form-dot-button"></div>
    <div class="last-cell">
      <div class="three-dots-heading" (click)="ellipsisClick($event,'item',opHeader)">
        <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
      </div>
    </div>
  </div>
  <div class="form-details-body">
    <div>
      <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div class="form-row" *ngFor="let formField of formFields">
          <form-field [formField]="formField" [form]="form"></form-field>
        </div>
        <div class="button-bar">
          <button *ngIf="!isLoading && servicerIdReady === true" type="button" (click)="resendPaymentNotification()">
            Resend Payment Notification
          </button>
        </div>
        <div class="button-bar">
          <div *ngFor="let singleButton of button">
            <button type="singleButton.type" [disabled]="singleButton.disabled" [hidden]="singleButton.hidden">
              {{singleButton.name}}
            </button>
          </div>
        </div>
      </form>
      <p-message severity="success" text="Record Saved" *ngIf="isSuccess"></p-message
      ><p-message severity="error" text="Please fill required fields" *ngIf="isFailed"></p-message>
    </div>
  </div>
</div>
<p-popover #opHeader
  ><p-listbox
    [options]="ellipsisHeaderOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event, opHeader) : ellipsisOptionClick($event)"
  >
  </p-listbox></p-popover
><history-item-modal
  modalTitle="Servicer Profile History"
  [(displayDialog)]="displayHistory"
  [formData]="historyData"
  *ngIf="displayHistory"
></history-item-modal>
